<div class="delete-photo-overlay">
    <div class="header">Confirm Deletion</div>
    <div class="delete-photo-overlay-content">
        <div>
            <h3>Are you sure you want to delete this photo?</h3>
        </div>
        <div class="model-button">
            <button class="btn btn-grey" (click)="shouldDeletePhoto(false)">Cancel</button>
            <button class="btn btn-danger" (click)="shouldDeletePhoto(true)">DELETE</button>
        </div>
    </div>
</div>
